import { type ReactNode } from "react";
import { FaCheck, FaRegClock } from "react-icons/fa";
import { Button } from "../../../components/core/basic/Button";
import { css } from "../../../../styled-system/css";

interface Props {
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  justify?: string;
  onPress?: () => void;
  successIcon?: boolean;
  /** Step is done but unconfirmed. Shown in place of the success check, never alongside it. */
  pendingIcon?: boolean;
  /** Accessible name for whichever status icon is showing. */
  statusLabel?: string;
  isDisabled?: boolean;
  isPending?: boolean;
}

const DialogueCard = ({
  title,
  description,
  children,
  justify = "start",
  onPress = () => {},
  successIcon,
  pendingIcon,
  statusLabel,
  isDisabled,
  isPending,
}: Props) => {
  return (
    <div
      className={css({
        width: "100%",
      })}
    >
      <div
        className={css({
          display: "flex",
          alignItems: "center",
          width: "100%",
        })}
      >
        <Button
          variant="flat"
          onPress={onPress}
          isDisabled={isDisabled}
          isPending={isPending}
          className={css({
            justifyContent: justify,
            borderBottomRadius: children ? "0" : undefined,
            width: "100%",
          })}
        >
          <span
            className={css({
              fontSize: "large",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "normal",
            })}
          >
            {title ?
              <strong
                className={css({
                  paddingRight: description ? "large" : "0",
                })}
              >
                {title}
              </strong>
            : null}
            {description}
          </span>
          {pendingIcon && !successIcon ?
            <FaRegClock
              title={statusLabel}
              className={css({
                flexShrink: 0,
                width: "65px",
                minWidth: "65px",
                height: "30px",
                marginLeft: "auto",
                padding: "4px",
                color: "trellisPalette.16",
                fontWeight: "bold",
              })}
            />
          : <FaCheck
              title={statusLabel}
              className={css({
                visibility: successIcon ? "visible" : "hidden",
                flexShrink: 0,
                width: "65px",
                minWidth: "65px",
                height: "30px",
                marginLeft: "auto",
                padding: "4px",
                color: "trellisPalette.12",
                fontWeight: "bold",
              })}
            />
          }
        </Button>
      </div>

      {children && (
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid",
            borderColor: "#dee2e6",
            borderTop: "none",
            padding: "large",
            backgroundColor: "#f8f9fa",
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default DialogueCard;
